export default "__VITE_ASSET__BAByaVQf__"